import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/store';

interface IGridsInitialState {
  [gridName: string]: any;
}

interface IUpdateColAction {
  gridName: string;
  gridState: any;
}

const initialState: IGridsInitialState = {};

export const gridsSlice = createSlice({
  name: 'grids',
  initialState,
  reducers: {
    updateGridState: (state, { payload: { gridName, gridState } }: PayloadAction<IUpdateColAction>) => {
      state[gridName] = gridState;
    },
    resetGridsState: (_state) => initialState,
  },
});

export const { updateGridState, resetGridsState } = gridsSlice.actions;

export const selectGridState =
  (gridName = '') =>
  (state: RootState) =>
    state.grids[gridName];
